import { render, staticRenderFns } from "./trace-info-modal.vue?vue&type=template&id=06b0f48c&"
import script from "./trace-info-modal.vue?vue&type=script&lang=js&"
export * from "./trace-info-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports